import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeForm, DTypeFormTableWithFixedRowsField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol, SELECTWITHGIVENOPTIONS_COLUMN_URI } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { cloneDeep } from 'lodash-es';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DTypeService } from '../../dtype.service';
import { FuseConfirmationService } from '../../../../../@fuse/services/confirmation/confirmation.service';


@Component({
    selector: 'tablewithfixedrows-field-component',
    templateUrl: './tablewithfixedrows-field.component.html',
    imports: [],
    styles: [
        /* language=SCSS */
        `
            .component-grid {
                grid-template-columns: 70px 70px auto;

                @screen sm {
                    grid-template-columns: 70px 70px auto;
                }

                @screen md {
                    grid-template-columns: 70px 70px auto;
                }

                @screen lg {
                    grid-template-columns: 70px 70px auto;
                }
                @screen xl {
                    grid-template-columns: 70px 70px auto;
                }
                @screen 2xl {
                    grid-template-columns: 70px 70px auto;
                }
                @screen 3xl {
                    grid-template-columns: 70px 70px auto;
                }
            }

            .error-panel {
                border-style: solid;
                border-width: 1px;
                border-color: red;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class DtypeTableWithFixedRowsFieldComponent implements OnInit, DTypeFormFieldComponent {

    @Input() field: DTypeFormTableWithFixedRowsField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;


    embeddedForms: DTypeForm[];

    options: [] = [];
    hiddenOptions: any[] = [];

    selectHidden: boolean = true;

    panelOpenState = false;


    constructor(private dtypeService: DTypeService,
        private _fuseConfirmationService: FuseConfirmationService,
        private translocoService: TranslocoService) { }

    async ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
        this.embeddedForms = this.field.embeddedForms;
        for (const column of this.field.tableWithFixedRows.dType.column) {
            if (column.type === SELECTWITHGIVENOPTIONS_COLUMN_URI && column['hidden'] === false) {
                this.selectHidden = false;
            }
        }
        if (this.selectHidden) {
            for (const field of Object.values(this.embeddedForms[0]?.fields)) {
                if (field['_hidden'] === true) {
                    this.options = cloneDeep(field['options']);
                    if (this.options.length > 5) {
                        this.hiddenOptions = cloneDeep(field['options']);
                    }
                }
            }
        } else {
            this.warningDialog(this.translocoService.translate('selectShouldBeHidden'));
        }

    }

    toggleHide(opt, event) {
        event.stopPropagation();
        const hidden = this.hiddenOptions.find(o => opt.code === o.code);
        if (hidden) {
            const index = this.hiddenOptions.findIndex(h => h === hidden);
            this.hiddenOptions.splice(index, 1);
        } else {
            this.hiddenOptions.push(opt);
        }
    }

    isHide(opt) {
        return this.hiddenOptions.find(o => opt.code === o.code);
    }

    controlHasErrors(form: DTypeForm) {
        return form.control.touched && !form.control.valid;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    private warningDialog(message: string) {
        const dialog = this._fuseConfirmationService.open({
            title: this.translocoService.translate('warning'),
            message: message,
            actions: {
                confirm: {
                    label: this.translocoService.translate('accept')
                },
                cancel: {
                    label: this.translocoService.translate('cancel'),
                    show: false
                }
            }
        });
    }
}


